import angular from 'angular';

import gridHeight from '../../../core/shared-service/grid-utils';

class ModalGroupListSubEntitiesCtrl {
     /*@ngInject*/
  constructor(PrincipalSvc) {
    this.PrincipalSvc = PrincipalSvc;
  }
    $onInit() {
    	var ctrl = this;
    	// Gestion de la grille
        this.gridOptions = {
            columnDefs: this.resolve.cols,
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: true,
            onRegisterApi: function(gridApi) {
                ctrl.gridApi = gridApi;
            }
        };
        this.gridOptions.data= this.resolve.entities;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    getSubEntityFromLegalEntity(){

        this.gridOptions.totalItems = this.gridOptions.data.length;

    }


    confirm() {
    	var rows = this.gridApi.selection.getSelectedRows();
    	if (rows) {
    		this.modalInstance.close({rows:rows,legalEntity:this.legalEntitySelected});
    	}
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }
}

angular.module('app.principal').component('modalGroupListSubEntities', {
    templateUrl: require('./modal-group-list-sub-entities.html'),
    controller: ModalGroupListSubEntitiesCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
